import * as React from 'react';
/**
 * @function
 * @name forwardRef
 * @description Use this function to forwardRef a component and create a `FloraComponent` component
 * @tutorial https://flora.gb.tech/docs/components/core/utils
 */
export var forwardRef = component => {
  return /*#__PURE__*/React.forwardRef(component);
};
//# sourceMappingURL=functions.js.map